import { motion } from "motion/react"
import { ComponentProps } from "react"

interface ExclamationMarksProps extends ComponentProps<"svg"> {
  startAnimation: boolean
  delay?: number
}

export function ExclamationMarks({
  startAnimation,
  delay = 0,
  ...props
}: ExclamationMarksProps) {
  return (
    <svg
      width="221"
      height="186"
      viewBox="0 0 221 186"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#FFFAF4"
      strokeWidth="3"
      strokeLinecap="round"
      {...props}
    >
      <g>
        <motion.path
          initial={{ pathLength: 0, opacity: 0 }}
          transition={{
            opacity: {
              duration: 0.5,
              delay: delay + 0.3,
            },
            pathLength: { duration: 0.5, delay: delay },
          }}
          animate={{
            opacity: startAnimation ? 1 : 0,
            pathLength: startAnimation ? 1 : 0,
          }}
          d="M20.3706 54.4728C29.6356 51.4971 39.0417 48.9056 48.4092 46.2746C51.3235 45.456 53.3719 44.8744 56.2292 44.2217C58.6906 43.6594 61.6566 42.789 64.2113 42.8305C65.5736 42.8527 65.5293 43.3962 64.9947 44.5323C63.899 46.8607 62.07 48.8682 60.7267 51.0557C60.0213 52.2046 59.8151 52.8072 59.2681 54.1081C57.4246 58.4926 55.6529 62.9142 54.0277 67.3846C49.7239 79.2234 46.3877 91.3815 42.8852 103.473C39.9236 113.697 36.8397 123.898 34.2008 134.213C33.219 138.05 32.1308 141.973 31.5941 145.909C31.4724 146.802 31.0707 144.786 30.7973 144.423C28.9301 141.948 25.0439 141.899 22.2749 141.992C17.346 142.159 12.4702 143.274 7.72888 144.558C6.80015 144.81 3.36097 146.494 4.52793 144.302C6.03062 141.479 7.12656 138.593 7.91796 135.482C9.92101 127.608 10.9216 119.416 11.9698 111.374C13.3775 100.574 14.1769 89.758 14.8331 78.8918C15.2395 72.1617 15.9008 65.4738 16.5754 58.7677C16.7426 57.1052 16.8375 55.5259 17.4533 53.9866"
        />
        <motion.path
          initial={{ pathLength: 0, opacity: 0 }}
          transition={{
            opacity: {
              duration: 0.5,
              delay: delay + 0.3,
            },
            pathLength: { duration: 0.5, delay: delay + 0.3 },
          }}
          animate={{
            pathLength: startAnimation ? 1 : 0,
            opacity: startAnimation ? 1 : 0,
          }}
          d="M6.26888 161.44C7.9715 156.865 12.9136 154.026 17.668 154.498C28.7931 155.602 30.9159 169.884 25.8257 177.904C20.8516 185.741 8.91952 187.1 3.47312 178.836C-1.31273 171.575 6.64938 163.808 11.8604 159.496"
        />
        <motion.path
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{
            pathLength: startAnimation ? 1 : 0,
            opacity: startAnimation ? 1 : 0,
          }}
          transition={{
            opacity: {
              duration: 0.5,
              delay: delay + 0.3,
            },
            pathLength: { duration: 0.5, delay: delay },
          }}
          d=" M12.6523 181.317C14.3868 180.546 16.0815 177.275 17.1149 175.849C18.9027 173.382 20.5793 170.841 22.2687 168.307 M11.5195 173.399C12.5371 168.989 17.2007 164.947 20.0046 161.52 M16.6104 162.085C11.3156 163.497 16.4817 154.449 17.7417 152.469 M15.4805 121.356C20.0151 120.542 23.3215 115.614 26.2911 112.526C32.0732 106.512 37.7136 100.472 43.1983 94.2041 M23.3984 115.7C23.7097 114.455 23.4277 115.441 25.3469 112.998C30.1195 106.921 34.9992 100.931 39.5829 94.7076C43.3202 89.6336 46.625 84.5201 49.4193 78.9316 M32.4492 89.6788C37.5016 82.6055 43.3544 76.2937 47.7223 68.749 M23.9648 85.719C32.3061 75.4152 41.1277 65.4876 49.42 55.1729 M24.5312 75.5365C27.2346 70.516 32.001 66.3129 35.7818 62.1489C39.5755 57.9707 42.5263 54.1011 45.4611 49.5156 M30.7539 58.5671C37.7697 53.5301 45.2486 49.5921 52.815 45.5566 M20.0039 129.275C23.642 125.502 27.4189 121.81 31.3173 118.527 M16.6133 142.286C23.3066 135.437 29.613 128.059 36.9774 121.922"
        />
      </g>
      <g>
        <motion.path
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{
            pathLength: startAnimation ? 1 : 0,
            opacity: startAnimation ? 1 : 0,
          }}
          transition={{
            opacity: {
              duration: 0.5,
              delay: delay + 0.6,
            },
            pathLength: { duration: 0.5, delay: delay },
          }}
          d="M81.0965 41.5974C82.5415 40.1524 85.26 39.6949 87.1304 39.1461C95.7608 36.6139 104.345 33.9309 112.963 31.3525C122.42 28.5227 131.822 25.235 141.435 22.9617C143.775 22.4082 150.802 20.1282 148.097 24.9415C144.867 30.6877 141.071 36.021 138.041 41.9116C129.903 57.7326 123.444 74.3139 116.922 90.8421C112.501 102.047 107.449 113.048 103.346 124.374C102.252 127.395 101.822 130.718 100.612 133.676C99.7779 135.715 95.3333 129.687 93.9184 128.962C89.563 126.73 84.7118 126.696 79.9652 127.265C78.4361 127.448 69.2229 130.471 68.9661 127.454C68.5769 122.881 71.7926 116.604 72.9572 112.369C76.8751 98.1219 79.459 83.5475 81.1594 68.8753C82.2907 59.1135 82.7935 49.3436 82.7935 39.5233C82.7935 35.9725 82.7502 36.4618 82.2279 39.3347"
        />
        <motion.path
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{
            pathLength: startAnimation ? 1 : 0,
            opacity: startAnimation ? 1 : 0,
          }}
          transition={{
            opacity: {
              duration: 0.5,
              delay: delay + 0.6,
            },
            pathLength: { duration: 0.5, delay: delay + 0.6 },
          }}
          d="M76.5737 151.337C75.3684 146.998 72.213 143.145 68.78 148.257C64.3007 154.926 66.246 170.744 76.008 172.015C87.3934 173.497 90.3472 155.4 87.6356 147.88C85.8938 143.049 81.8842 141.096 76.8879 142.286C69.9859 143.929 68.1793 148.739 64.1289 153.599"
        />
        <motion.path
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{
            opacity: startAnimation ? 1 : 0,
            pathLength: startAnimation ? 1 : 0,
          }}
          transition={{
            opacity: {
              duration: 0.5,
              delay: delay + 0.6,
            },
            pathLength: { duration: 0.5, delay: delay + 0.6 },
          }}
          d="M86.1875 117.396C94.6166 110.054 101.56 100.293 108.249 91.375 M82.7969 108.345C91.1391 100.32 98.7859 91.5003 106.366 82.7646C109.235 79.4592 112.501 76.0896 114.474 72.1426 M91.2812 87.4156C102.585 76.4443 113.808 65.4595 124.656 54.041 M102.027 67.0523C111.483 56.3636 123.94 48.0637 134.271 38.2031 M102.027 58.0018C113.11 48.7521 124.213 39.5257 135.276 30.2525C138.001 27.9683 143.042 24.0596 137.099 27.4556 M103.727 48.3848C106.475 42.3373 115.971 36.7303 120.948 32.8603C125.58 29.2587 130.413 26.0009 135.404 22.9297 M77.1367 162.084C80.0871 159.571 82.1414 156.067 84.4904 153.033 M78.2695 157.559C80.0307 153.713 81.987 150.003 83.9262 146.246 M79.4025 147.378C77.4449 144.985 86.892 135.928 88.4532 134.367"
        />
      </g>
      <g>
        <motion.path
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{
            pathLength: startAnimation ? 1 : 0,
            opacity: startAnimation ? 1 : 0,
          }}
          transition={{
            opacity: {
              duration: 0.5,
              delay: delay + 0.9,
            },
            pathLength: { duration: 0.5, delay: delay + 0.9 },
          }}
          d="M171.04 16.142C179.29 13.9576 187.516 11.7331 195.899 10.1082C202.387 8.85043 210.669 6.71335 217.205 8.94542C218.966 9.54668 220.067 10.6721 218.682 12.0566C216.037 14.7025 213.916 17.6237 212.114 20.9188C201.235 40.8208 194.444 63.2417 187.256 84.651C184.52 92.8022 181.676 100.924 179.211 109.163C178.756 110.686 178.284 115.621 177.011 116.894C176.613 117.293 174.963 116.031 174.812 115.951C171.76 114.349 168.303 114.129 164.912 114.129C159.967 114.129 155.042 114.793 150.142 115.386C148.782 115.55 144.754 116.962 145.868 114.38C152.619 98.7311 155.107 81.4111 159.036 64.9153C163.143 47.6681 167.956 30.5104 175.566 14.445"
        />
        <motion.path
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{
            pathLength: startAnimation ? 1 : 0,
            opacity: startAnimation ? 1 : 0,
          }}
          transition={{
            opacity: {
              duration: 0.5,
              delay: delay + 0.9,
            },
            pathLength: { duration: 0.5, delay: delay + 0.9 },
          }}
          d="M156.332 133.801C152.366 130.33 145.687 136.465 144.453 139.961C141.465 148.429 143.244 166.083 156.521 162.713C167.861 159.835 174.799 140.958 169.657 130.91C164.743 121.306 153.021 131.975 148.413 135.498"
        />
        <motion.path
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{
            pathLength: startAnimation ? 1 : 0,
            opacity: startAnimation ? 1 : 0,
          }}
          transition={{
            opacity: {
              duration: 0.5,
              delay: delay + 0.9,
            },
            pathLength: { duration: 0.5, delay: delay + 0.9 },
          }}
          d="M151.242 154.165C156.116 151.178 159.274 145.12 162.556 140.589 M150.676 143.418C148.653 142.968 153.039 139.974 154.542 138.547C158.272 135.002 162.134 131.597 165.949 128.145 M159.724 130.973C153.692 133.646 157.441 130.304 158.593 127.014 M162.555 102.689C169.066 93.6974 176.838 85.5244 183.987 77.0453C186.09 74.5514 188.425 72.2112 190.147 69.4402C190.227 69.3106 189.843 69.3827 189.707 69.3145 M163.121 83.4563C173.086 72.9318 182.302 61.881 191.405 50.6475 M176.129 55.1735C182.471 51.3684 187.736 44.9573 193.099 39.9004 M177.828 44.4249C180.849 39.9948 185.844 36.2854 189.644 32.6086C195.635 26.8137 200.763 20.7777 206.112 14.4443 M185.18 24.6268C194.034 16.8411 203.152 9.39509 212.332 2"
        />
      </g>
    </svg>
  )
}
